<template>
  <div class="page-address-add">
    <van-address-edit
      show-postal
      :area-list="getAreaList(regionData)"
      @save="onSave">
      <van-field
        v-model="model.receivingAddress"
        clearable
        label="收货单位"
        placeholder="利于送货司机快速定位"
      />
      </van-address-edit>
  </div>
</template>
<script>
/**
 * 新增地址
 * @author xieyang
 */
import FormMixins from '~/mixins/form-mixins'
import { regionData, TextToCode } from 'element-china-area-data'
import api from 'api/address'
export default {
  mixins: [FormMixins],
  name: 'page-address-add',
  data () {
    return {
      model: {
        name: null,
        mobile: null,
        province: null,
        city: null,
        district: null,
        detailedInformation: null,
        postcode: null,
        receivingAddress: null
      },
      regionData: regionData
    }
  },
  computed: {
  },
  methods: {
    getAreaList (list) {
      let cityObj = {
        province_list: {},
        city_list: {},
        county_list: {}
      }
      for (let province of list) {
        this.$set(cityObj.province_list, province.value, province.label)
        if (province['children']) {
          for (let city of province.children) {
            this.$set(cityObj.city_list, city.value, city.label)
            if (city['children']) {
              for (let district of city['children']) {
                this.$set(cityObj.county_list, district.value, district.label)
              }
            }
          }
        }
      }
      return cityObj
      // return CodeToText['120105']
    },
    onSave (data) {
      this.model.name = data.name
      this.model.mobile = data.tel
      this.model.province = TextToCode[data.province].code
      this.model.city = TextToCode[data.province][data.city].code
      this.model.district = data.areaCode
      this.model.detailedInformation = data.addressDetail
      this.model.postcode = data.postalCode
      this.$nextTick(() => {
        this.addPostAddress()
      })
    },
    addPostAddress () {
      let vm = this
      api.addPostAddress(this.model).then(res => {
        if (res.type === 'SUCCESS') {
          vm.$router.go(-1)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../../../assets/css/var.scss';
  .page-address-add {
    background-color: $white;
    height: 100%;
    .van-address-edit {
      /deep/ .van-address-edit__buttons {
        position: absolute;
        bottom: 20px;
        width: 100%;
        padding: 0;
        .van-button {
          width: 90%;
          margin: 0 auto;
          border-radius: 20px;
          height: 30px;
          line-height: 30px;
          background-color: $blue;
          border: none;
        }
      }
    }
  }
</style>
